import unit1 from "../assets/sdbeji.png";
import unit2 from "../assets/smpbeji.png";
import unit3 from "../assets/smabeji.png";
import unit4 from "../assets/sdpancoranmas.png";
import unit5 from "../assets/smppancoranmas.png";
import unit6 from "../assets/smapancoranmas.png";
import unit7 from "../assets/sdsukmajaya.png";
import unit8 from "../assets/smpsukmajaya.png";
import unit9 from "../assets/smasukmajaya.png";
import unit10 from "../assets/sdcinere.png";
import unit11 from "../assets/smpcinere.png";
import unit12 from "../assets/smacinere.png";
import unit13 from "../assets/sdcimanggis.png";
import unit14 from "../assets/smpcimanggis.png";
import unit15 from "../assets/smacimanggis.png";
import unit16 from "../assets/sdcilodong.png";

export default function Unit2() {
  return (
    <>
      <style>
        {`
          @keyframes fadeInUp {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>
      <section className="text-gray-600 body-font">
        <div className="container px-5 py-2 mx-auto">
          <h1
            className="
              sm:text-3xl text-center text-2xl font-medium title-font mb-4 text-gray-900
              opacity-0 animate-[fadeInUp_1s_ease-out_forwards]
            "
          >
            Persebaran Distribusi MBG Berdasarkan <br /> Setiap SPPG
          </h1>
          <br /> <br />
          <div className="flex flex-wrap -m-4">
            <div
              className="lg:w-1/4 md:w-1/2 p-4 w-full mt-3 opacity-0 animate-[fadeInUp_0.8s_ease-out_forwards]"
              style={{ animationDelay: "0.1s" }}
            >
              <a className="block relative h-48 rounded overflow-hidden">
                <img className="object-cover object-center w-full h-full block" src={unit1} />
              </a>
              <div className="mt-4">
                <h4 className="text-sm">Unit SPPG Beji</h4>
                <h2 className="text-gray-900 title-font text-lg font-medium">SD Negeri 1 Beji</h2>
              </div>
            </div>
            <div
              className="lg:w-1/4 md:w-1/2 p-4 w-full mt-3 opacity-0 animate-[fadeInUp_0.8s_ease-out_forwards]"
              style={{ animationDelay: "0.2s" }}
            >
              <a className="block relative h-48 rounded overflow-hidden">
                <img className="object-cover object-center w-full h-full block" src={unit2} />
              </a>
              <div className="mt-4">
                <h4 className="text-sm">Unit SPPG Beji</h4>
               <h2 className="text-gray-900 title-font text-lg font-medium"> SMP Negeri 1 Beji</h2>
              </div>
            </div>
            <div
              className="lg:w-1/4 md:w-1/2 p-4 w-full mt-3 opacity-0 animate-[fadeInUp_0.8s_ease-out_forwards]"
              style={{ animationDelay: "0.3s" }}
            >
              <a className="block relative h-48 rounded overflow-hidden">
                <img className="object-cover object-center w-full h-full block" src={unit3} />
              </a>
              <div className="mt-4">
                <h4 className="text-sm">Unit SPPG Beji</h4>
                <h2 className="text-gray-900 title-font text-lg font-medium">SMA Negeri 1 Beji</h2>
              </div>
            </div>
            <div
              className="lg:w-1/4 md:w-1/2 p-4 w-full mt-3 opacity-0 animate-[fadeInUp_0.8s_ease-out_forwards]"
              style={{ animationDelay: "0.4s" }}
            >
              <a className="block relative h-48 rounded overflow-hidden">
                <img className="object-cover object-center w-full h-full block" src={unit4} />
              </a>
              <div className="mt-4">
                <h4 className="text-sm">Unit SPPG Pancoran Mas</h4>
                <h2 className="text-gray-900 title-font text-lg font-medium">SD Negeri 1 Pancoran Mas</h2>
              </div>
            </div>
            <div
              className="lg:w-1/4 md:w-1/2 p-4 w-full mt-3 opacity-0 animate-[fadeInUp_0.8s_ease-out_forwards]"
              style={{ animationDelay: "0.5s" }}
            >
              <a className="block relative h-48 rounded overflow-hidden">
                <img className="object-cover object-center w-full h-full block" src={unit5} />
              </a>
              <div className="mt-4">
                <h4 className="text-sm">Unit SPPG Pancoran Mas</h4>
                <h2 className="text-gray-900 title-font text-lg font-medium">SMP Negeri 1 Pancoran Mas</h2>
              </div>
            </div>
            <div
              className="lg:w-1/4 md:w-1/2 p-4 w-full mt-3 opacity-0 animate-[fadeInUp_0.8s_ease-out_forwards]"
              style={{ animationDelay: "0.6s" }}
            >
              <a className="block relative h-48 rounded overflow-hidden">
                <img className="object-cover object-center w-full h-full block" src={unit6} />
              </a>
              <div className="mt-4">
                <h4 className="text-sm">Unit SPPG Pancoran Mas</h4>
                <h2 className="text-gray-900 title-font text-lg font-medium">SMA Negeri 1 Pancoran Mas</h2>
              </div>
            </div>
            <div
              className="lg:w-1/4 md:w-1/2 p-4 w-full mt-3 opacity-0 animate-[fadeInUp_0.8s_ease-out_forwards]"
              style={{ animationDelay: "0.7s" }}
            >
              <a className="block relative h-48 rounded overflow-hidden">
                <img className="object-cover object-center w-full h-full block" src={unit7} />
              </a>
              <div className="mt-4">
                <h4 className="text-sm">Unit SPPG Sukmajaya</h4>
                <h2 className="text-gray-900 title-font text-lg font-medium">SD Negeri 1 Sukmajaya</h2>
              </div>
            </div>
            <div
              className="lg:w-1/4 md:w-1/2 p-4 w-full mt-3 opacity-0 animate-[fadeInUp_0.8s_ease-out_forwards]"
              style={{ animationDelay: "0.8s" }}
            >
              <a className="block relative h-48 rounded overflow-hidden">
                <img className="object-cover object-center w-full h-full block" src={unit8} />
              </a>
              <div className="mt-4">
                <h4 className="text-sm">Unit SPPG Sukmajaya</h4>
                <h2 className="text-gray-900 title-font text-lg font-medium">SMP Negeri 1 Sukmajaya</h2>
              </div>
            </div>
            <div
              className="lg:w-1/4 md:w-1/2 p-4 w-full mt-3 opacity-0 animate-[fadeInUp_0.8s_ease-out_forwards]"
              style={{ animationDelay: "0.9s" }}
            >
              <a className="block relative h-48 rounded overflow-hidden">
                <img className="object-cover object-center w-full h-full block" src={unit9} />
              </a>
              <div className="mt-4">
                <h4 className="text-sm">Unit SPPG Sukmajaya</h4>
                <h2 className="text-gray-900 title-font text-lg font-medium">SMA Negeri 1 Sukmajaya</h2>
              </div>
            </div>
            <div
              className="lg:w-1/4 md:w-1/2 p-4 w-full mt-3 opacity-0 animate-[fadeInUp_0.8s_ease-out_forwards]"
              style={{ animationDelay: "1.0s" }}
            >
              <a className="block relative h-48 rounded overflow-hidden">
                <img className="object-cover object-center w-full h-full block" src={unit10} />
              </a>
              <div className="mt-4">
                <h4 className="text-sm">Unit SPPG Cinere</h4>
                <h2 className="text-gray-900 title-font text-lg font-medium">SD Negeri 1 Cinere</h2>
              </div>
            </div>
            <div
              className="lg:w-1/4 md:w-1/2 p-4 w-full mt-3 opacity-0 animate-[fadeInUp_0.8s_ease-out_forwards]"
              style={{ animationDelay: "1.1s" }}
            >
              <a className="block relative h-48 rounded overflow-hidden">
                <img className="object-cover object-center w-full h-full block" src={unit11} />
              </a>
              <div className="mt-4">
                <h4 className="text-sm">Unit SPPG Cinere</h4>       
                <h2 className="text-gray-900 title-font text-lg font-medium">SMP Negeri 1 Cinere</h2>
              </div>
            </div>
            <div
              className="lg:w-1/4 md:w-1/2 p-4 w-full mt-3 opacity-0 animate-[fadeInUp_0.8s_ease-out_forwards]"
              style={{ animationDelay: "1.2s" }}
            >
              <a className="block relative h-48 rounded overflow-hidden">
                <img className="object-cover object-center w-full h-full block" src={unit12} />
              </a>
              <div className="mt-4">
                <h4 className="text-sm">Unit SPPG Cinere</h4>
                <h2 className="text-gray-900 title-font text-lg font-medium">SMA Negeri 1 Cinere</h2>
              </div>
            </div>
            <div
              className="lg:w-1/4 md:w-1/2 p-4 w-full mt-3 opacity-0 animate-[fadeInUp_0.8s_ease-out_forwards]"
              style={{ animationDelay: "1.3s" }}
            >
              <a className="block relative h-48 rounded overflow-hidden">
                <img className="object-cover object-center w-full h-full block" src={unit13} />
              </a>
              <div className="mt-4">
                <h4 className="text-sm">Unit SPPG Cimanggis</h4>
                <h2 className="text-gray-900 title-font text-lg font-medium">SD Negeri 1 Cimanggis</h2>
              </div>
            </div>
            <div
              className="lg:w-1/4 md:w-1/2 p-4 w-full mt-3 opacity-0 animate-[fadeInUp_0.8s_ease-out_forwards]"
              style={{ animationDelay: "1.4s" }}
            >
              <a className="block relative h-48 rounded overflow-hidden">
                <img className="object-cover object-center w-full h-full block" src={unit14} />
              </a>
              <div className="mt-4">
                <h4 className="text-sm">Unit SPPG Cimanggis</h4>
                <h2 className="text-gray-900 title-font text-lg font-medium">SMP Negeri 1 Cimanggis</h2>
              </div>
            </div>
            <div
              className="lg:w-1/4 md:w-1/2 p-4 w-full mt-3 opacity-0 animate-[fadeInUp_0.8s_ease-out_forwards]"
              style={{ animationDelay: "1.5s" }}
            >
              <a className="block relative h-48 rounded overflow-hidden">
                <img className="object-cover object-center w-full h-full block" src={unit15} />
              </a>
              <div className="mt-4">
                <h4 className="text-sm">Unit SPPG Cimanggis</h4>
                <h2 className="text-gray-900 title-font text-lg font-medium">SMA Negeri 1 Cimanggis</h2>
              </div>
            </div>
            <div
              className="lg:w-1/4 md:w-1/2 p-4 w-full mt-3 opacity-0 animate-[fadeInUp_0.8s_ease-out_forwards]"
              style={{ animationDelay: "1.6s" }}
            >
              <a className="block relative h-48 rounded overflow-hidden">
                <img className="object-cover object-center w-full h-full block" src={unit16} />
              </a>
              <div className="mt-4">
                <h4 className="text-sm">Unit SPPG Cilodong</h4>
                <h2 className="text-gray-900 title-font text-lg font-medium">SD Negeri 1 Cilodong</h2>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
}
